/**
 * **Accor**
 *
 * @exports bs_237
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_237
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        thn.pageCheck();
    };
    /**
       * @memberOf module:bs_237
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const $ = window.jQuery;
        const $app = $ && $('#app-main');
        const stopObservation = function () {
            thn.stopObserveDom($app.get(0), thn.accorRoomsObserver);
            // Delete reference to the observer function
            delete thn.accorRoomsObserver;
        };
        if (!thn.accorRoomsObserver && $app && $app.length) {
            thn.accorRoomsObserver = function thnAccorRoomsObserver() {
                if ($app.find('#rooms-content .reborn-price__amount:visible').length) {
                    // Stop observation when the first price is visible
                    stopObservation();
                    // Update PW
                    ctx.widget.update();
                }
            };
            thn.observeDom($app.get(0), thn.accorRoomsObserver, {
                childList: true,
                subtree: true,
                characterData: false,
                attributes: true,
                attributeFilter: ['class'],
            });
        }
        // Change on the currency selector
        const currencySelectEv = thn.delegate('change', '.rooms__btn-bar__currency__select', function () {
            ctx.widget.logger.debug('Currency changed!');
            setTimeout(() => ctx.widget.refresh(), 200);
        });
        // Setup unload
        thn.pageUnload(function () {
            ctx.widget.logger.debug('Page unload: reset PW!');
            // Stop observation
            stopObservation();
            // Remove event listeners
            currencySelectEv();
            // Unload the PW for proper loading when returning to R&R
            ctx.widget.reset();
        });
    };
    /**
       * @memberOf module:bs_237
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // Dates
        widgetData.dateBegin = ((window.location.hash.match(new RegExp('dateIn=([^&]*)')) || [])[1] || '').replace(/-/g, '/');
        const nights = parseInt((window.location.hash.match(new RegExp('nights=([^&]*)')) || [])[1], 10) || 1;
        widgetData.dateEnd = widgetData.dateBegin && thn.dateToString(thn.addDays(widgetData.dateBegin, nights));
        // Guests, Adults & Children
        widgetData.adults = parseInt((window.location.hash.match(new RegExp('adults=([^&]*)')) || [])[1], 10) || 2;
        widgetData.children = parseInt((window.location.hash.match(new RegExp('children=([^&]*)')) || [])[1], 10) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // Prices & Currency || No Rooms can't be detected. When rooms are not available, the BE displays a message on the Calendar page
        const prices = $('.room-block__header__head-line__resume__offer__price.reborn-price').map((idx, price) => thn.parseNumber($(price).text())).toArray();
        if (prices.length) {
            widgetData.price = Math.min(...prices) / nights;
            widgetData.currency = thn.getCurrencyCode($('.currency-select select').val() || '');
            if (widgetData.price && widgetData.currency) {
                widgetData.set = true;
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_237
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        const $ = window.jQuery;
        // If booking data is not set yet
        if (!ctx.widget.isSet()) {
            const mainApp = $ && $('#app-main');
            if (mainApp && mainApp.length) {
                const observer = thn.debounce(function accorBookingObserver() {
                    if ($('.basket-total__container__line__price--final .price:visible').length) {
                        ctx.widget.logger.debug('Booking price displayed!');
                        if (ctx.widget.setData().isSet()) {
                            thn.stopObserveDom(mainApp.get(0), observer);
                            ctx.widget.save();
                        }
                    }
                }, 400);
                thn.observeDom(mainApp.get(0), observer, {
                    childList: true,
                    subtree: true,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class'],
                });
                thn.pageUnload(function () {
                    thn.stopObserveDom(mainApp.get(0), observer);
                });
            }
        }
    };
    /**
       * @memberOf module:bs_237
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        const bookingPriceVisible = $('.basket-total__container__line__price--final .price:visible').length;
        if (bookingPriceVisible) {
            // Booking ID
            widgetData.bookingId = ($('#reborn-confirmation-info-b2c-number').text() || '').trim();
            // Dates
            const dates = $('.date-mention__dates:eq(0)').text().match(/(\d+)\D+(\d+)\D+(\d+)/g);
            widgetData.dateBegin = dates && dates[0].replace(/-/g, '/');
            widgetData.dateEnd = dates && dates.length > 1 && dates[1].replace(/-/g, '/');
            // Price & Currency
            const finalPrice = $('.basket-total__container__line__price--final .price').text();
            widgetData.price = thn.parseNumber(finalPrice);
            widgetData.currency = thn.getCurrencyCode(finalPrice.match(/[^\d\s,.]+/)[0]);
        }
        else {
            widgetData.set = false;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
